export var SparkDataType;
(function (SparkDataType) {
    SparkDataType["Double"] = "double";
    SparkDataType["Timestamp"] = "timestamp";
    SparkDataType["String"] = "string";
    SparkDataType["Boolean"] = "boolean";
    SparkDataType["Decimal"] = "decimal";
})(SparkDataType || (SparkDataType = {}));
//# sourceMappingURL=sparkDataType.js.map